var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsObject, IsOptional, IsUUID } from 'class-validator';
import { UserStatsDto } from './user-stats.dto.js';
import { UserProfileDto } from './user.profile.dto.js';
export class UserStatsFullSizeDto {
    id;
    createdAt;
    updatedAt;
    userId;
    user;
    lastLogin;
    weeklyStats;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UserStatsFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], UserStatsFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], UserStatsFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UserStatsFullSizeDto.prototype, "userId", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Expose(),
    __metadata("design:type", Function)
], UserStatsFullSizeDto.prototype, "user", void 0);
__decorate([
    IsDateString(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], UserStatsFullSizeDto.prototype, "lastLogin", void 0);
__decorate([
    IsObject(),
    Type(() => UserStatsDto),
    Expose(),
    __metadata("design:type", UserStatsDto)
], UserStatsFullSizeDto.prototype, "weeklyStats", void 0);
//# sourceMappingURL=user-stats.full-size.dto.js.map